import React from 'react';
import {connect} from 'react-redux';
import {BaseStackSummary} from 'components/organisms/stack-summary/components/sports/nhl-2';
import $ from 'jquery';

class StackSummaryComponent extends BaseStackSummary {
    componentDidMount() {
        $('body').scrollTop(0);
    }

    render() {
        const {rawLineups} = this.props;
        const teams = this.prepareTeams();
        const lineupsQuantity = rawLineups.getQuantity();
        const teamsQuantity = teams.length;

        const content = this.getTeamsStackView(teams);

        return (
            <div className="tab-content stack-summary-content">
                <div className="lineups-info-holder">
                    <ul className="lineups-info">
                        <li>
                            <strong>{teamsQuantity}</strong> Teams Used
                        </li>
                        <li>
                            <strong>{lineupsQuantity}</strong> Lineups
                        </li>
                    </ul>
                </div>
                <div className="players-used-table table-holder">{content}</div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData,
    } = state;

    return {
        rawLineups: lineupsData.rawLineups,
    };
}

const StackSummary = connect(mapStatesToProps)(StackSummaryComponent);

export {StackSummary};
